export default __webpack_public_path__ + "static/media/TraxSmart.b3136535.png";